import { Stack } from "react-bootstrap";
import ErrorIcon from '@mui/icons-material/ErrorOutlineOutlined';
import SuccessIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import WarningIcon from '@mui/icons-material/WarningAmberRounded';
import { ICONS } from "Utils/icons";

export const PageInfo = ({ message, type, classes, combo, title }) => {

    if (classes == null) {
        classes = "";
    }
    if(combo!=null){
        switch (type) {
            case "info":
                return (
                    <Stack direction="vertical" className={"page-info--info combo d-flex align-items-center align-items-md-start  px-4 px-md-5" + classes}>
                        <div className="icon-container d-flex flex-column flex-md-row align-items-center justify-content-center">
                            {ICONS.info()}
                            <div className="title header2 text-center text-md-start">{title}</div>
                        </div>
                        <div className="message text-center text-md-start">
                            {message}
                        </div>
                    </Stack>
                );
            case "error":
                return (
                    <Stack direction="vertical" className={"page-info--error combo d-flex align-items-center align-items-md-start  px-4 px-md-5" + classes}>
                        <div className="icon-container d-flex flex-column flex-md-row align-items-center justify-content-center">
                            {ICONS.error()}
                            <div className="title header2 text-center text-md-start">{title}</div>
                        </div>
                        <div className="message text-center text-md-start">
                            {message}
                        </div>
                    </Stack>
                );
            case "batch_error":
                return (
                    <Stack direction="vertical" className={"page-info--error combo d-flex align-items-center align-items-md-start  px-4 px-md-5" + classes}>
                        <div className="icon-container d-flex flex-column flex-md-row align-items-center justify-content-center">
                            {ICONS.error()}
                            <div className="title header2 text-center text-md-start">{title}</div>
                        </div>
                        <div className="message text-center text-md-start">
                            {/* {message} */}
                            {Array.isArray(message) == true
                                ?
                                message.map((msg, index) => {
                                    if (index === 0) {
                                        return (<div style={{ "marginBottom": "5px" }}>{msg}</div>)
                                    } else {
                                        return (<div style={{ "marginBottom": "5px" }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{msg}</div>)
                                    }
                                })
                                : { message }}
                        </div>
                    </Stack>

                );
            case "warning":
                return (
                    <Stack direction="vertical" className={"page-info--warning combo d-flex align-items-center align-items-md-start  px-4 px-md-5" + classes}>
                        <div className="icon-container d-flex flex-column flex-md-row align-items-center justify-content-center">
                            {ICONS.warning()}
                            <div className="title header2 text-center text-md-start">{title}</div>
                        </div>
                        <div className="message text-center text-md-start">
                            {/* {message} */}
                            {Array.isArray(message) == true
                                ?
                                message.map((msg, index) => {
                                    if (index === 0 && message.length > 1) {
                                        return (<div className="font-weight-bold">{msg}</div>)
                                    } else if (index === 0 && message.length === 1) {
                                        return (<div>{msg}</div>)
                                    } else {
                                        return (<div>&nbsp;&nbsp;&nbsp;&nbsp;{msg}</div>)
                                    }
                                })
                                :  message }
                        </div>
                    </Stack>
                );
            case "success":
                return (
                    <Stack direction="vertical" className={"page-info--success combo d-flex align-items-center align-items-md-start  px-4 px-md-5" + classes}>
                        <div className="icon-container d-flex flex-row align-items-center">
                            {ICONS.success()}
                            <div className="title header2 text-center text-md-start">{title}</div>
                        </div>
                        <div className="message text-center text-md-start">
                            {message}
                        </div>
                    </Stack>
                );
            case "confirm":
                return (
                    <Stack direction="vertical" className={"page-info--info combo d-flex align-items-center align-items-md-start  px-4 px-md-5" + classes}>
                        <div className="icon-container d-flex flex-row align-items-center">
                            {ICONS.warning()}
                            <div className="title header2 text-center text-md-start">{title}</div>
                        </div>
                        <div className="message text-center text-md-start">
                            {message}
                        </div>
                    </Stack>
                );
            
        }
    }
    else{
        switch (type) {
            case "info":
                return (
                    <Stack direction="horizontal" className={"page-info--info " + classes}>
                        <div className="icon-container">
                            <InfoIcon fontSize="small"></InfoIcon>
                        </div>
                        <div className="message">
                            {message}
                        </div>
                    </Stack>
                );
            case "error":
                return (
                    <Stack direction="horizontal" className={"page-info--error " + classes}>
                        <div className="icon-container">
                            <ErrorIcon fontSize="small"></ErrorIcon>
                        </div>
                        <div className="message">
                            {message}
                        </div>
                    </Stack>
                );
            case "batch_error":
                return (
                    <Stack direction="horizontal" className={"page-info--error " + classes}>
                        <div className="icon-container">
                            <ErrorIcon fontSize="small"></ErrorIcon>
                        </div>
                        <div className="message">
                            {/* {message} */}
                            {Array.isArray(message) == true
                                ?
                                message.map((msg, index) => {
                                    if (index === 0) {
                                        return (<div style={{ "marginBottom": "5px" }}>{msg}</div>)
                                    } else {
                                        return (<div style={{ "marginBottom": "5px" }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{msg}</div>)
                                    }
                                })
                                : { message }}
                        </div>
                    </Stack>
                );
            case "warning":
                return (
                    <Stack direction="horizontal" className={"page-info--warning " + classes}>
                        <div className="icon-container">
                            <WarningIcon fontSize="small"></WarningIcon>
                        </div>
                        <div className="message">
                            {/* {message} */}
                            {Array.isArray(message) == true
                                ?
                                message.map((msg, index) => {
                                    if (index === 0 && message.length > 1) {
                                        return (<div className="font-weight-bold">{msg}</div>)
                                    } else if (index === 0 && message.length === 1) {
                                        return (<div>{msg}</div>)
                                    } else {
                                        return (<div>&nbsp;&nbsp;&nbsp;&nbsp;{msg}</div>)
                                    }
                                })
                                :  message }
                        </div>
                    </Stack>
                );
            case "success":
                return (
                    <Stack direction={"horizontal"} className={"page-info--success " + classes}>
                        <div className="icon-container">
                            <SuccessIcon fontSize="small"></SuccessIcon>
                        </div>
                        <div className="message">
                            {message}
                        </div>
                    </Stack>
                );
            case "confirm":
                return (
                    <Stack direction="horizontal" className={"page-info--info " + classes}>
                        <div className="icon-container">
                            <InfoIcon fontSize="small"></InfoIcon>
                        </div>
                        <div className="message">
                            {message}
                        </div>
                    </Stack>
                );
            default:
                return (
                    <>
                        <Stack direction="horizontal" className="page-info--info mb-2">
                            <div className="icon-container">
                                <InfoIcon fontSize="small"></InfoIcon>
                            </div>
                            <div className="message">
                                {message}
                            </div>
                        </Stack>
                        <Stack direction="horizontal" className="page-info--error mb-2">
                            <div className="icon-container">
                                <ErrorIcon fontSize="small"></ErrorIcon>
                            </div>
                            <div className="message">
                                {message}
                            </div>
                        </Stack>
                        <Stack direction="horizontal" className="page-info--warning mb-2">
                            <div className="icon-container">
                                <WarningIcon fontSize="small"></WarningIcon>
                            </div>
                            <div className="message">
                                {message}
                            </div>
                        </Stack>
                        <Stack direction="horizontal" className="page-info--success mb-2">
                            <div className="icon-container">
                                <SuccessIcon fontSize="small"></SuccessIcon>
                            </div>
                            <div className="message">
                                {message}
                            </div>
                        </Stack>
                    </>
                );
        }
    }
    
}